import {useIdleTimer} from 'react-idle-timer';
import {logoutStart} from './redux/actions';
import {selectAuth} from './redux/selectors';
import {connect} from 'react-redux';
import {useEffect} from 'react';

const IdleTimerComponent =({auth, handleLogoutStart})=>{

  const onIdle = () => {
    if(auth.loggedIn) {
      handleLogoutStart();
      alert('You have been idle for too long! Logging out...');
    }
  };
  const onActive = event => {
    console.log('User is active again!', event);
  };

  const onAction = event => {
    console.log('User did something!', event);
  };

  useEffect(() => {
    const handleBeforeUnload = event => {
      // Standard way to show a confirmation dialog:
      event.preventDefault();
      handleLogoutStart();
      console.log('User is about to leave the page!');
      event.returnValue = ''; // Some browsers require setting this
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useIdleTimer({
    timeout: 1000 * 60 * 15, // 5 minutes
    onIdle,
    onActive,
    onAction,
    debounce: 500,
  });
};

const actions = {
  handleLogoutStart: logoutStart,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState, actions)(IdleTimerComponent);
